import { StyleSheet, TouchableOpacity } from 'react-native'
import { DS } from '../../../design-system'
import ProgressCircle from '../components/ProgressCircle'
import { ChapterModelType } from '../../../models/api-store'
import { fontFamily } from '../../../theme'
import { observer } from 'mobx-react-lite'
import { useCallback } from 'react'
import { useRemoteConfig } from '../../../../module/remote-config/useRemoteConfig'

interface ChapterProps {
  chapter: ChapterModelType
  isCurrentChapter: boolean
  isVideoPlaying: boolean
  onPress: (_id: string | undefined | null) => void
  isUserSubscriber: boolean
}

export const Chapter = observer(
  ({ chapter, isCurrentChapter, isVideoPlaying, onPress, isUserSubscriber }: ChapterProps) => {
    const isLearningUnlocked = useRemoteConfig((state) => state.is_learning_unlocked)

    const handleStatus = useCallback(() => {
      if (isCurrentChapter) {
        if (isVideoPlaying) {
          return 'Playing'
        }

        return 'Resume'
      }

      if (!chapter.duration) return

      const totalSeconds = Math.round(chapter.duration)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = totalSeconds % 60

      return `${minutes} min ${seconds} sec`
    }, [chapter, isVideoPlaying, isCurrentChapter])

    const handlePlay = () => {
      if (isVideoPlaying) {
        return null
      }

      if (isCurrentChapter) {
        return <DS.Icon name="Play--black" size={24} />
      }
      return null
    }

    const handleIcon = () => {
      if (!isLearningUnlocked && chapter.membership !== 'free' && !isUserSubscriber) {
        return <DS.Icon name="Lock-Locked" size={20} color="Global/Black" />
      }

      if (chapter.completed) {
        return <DS.Icon name="CheckThick" size={20} color="Brand/Green" />
      }

      if (!chapter.completed && chapter.currentPosition) {
        if (chapter.duration) {
          return (
            <ProgressCircle
              progress={(chapter.currentPosition * 1000) / (chapter.duration * 1000)}
              size={20}
              strokeWidth={2}
            />
          )
        }
      }

      return <DS.Icon name="Circle" size={20} color="Brand/Light Grey" />
    }

    return (
      <TouchableOpacity onPress={() => onPress(chapter._id)}>
        <DS.Frame row>
          <DS.Frame style={styles.icon}>{handleIcon()}</DS.Frame>
          <DS.Frame style={styles.lessonBox}>
            <DS.Frame>
              <DS.Text variant="Body Medium/Medium" style={styles.lessonName}>
                {chapter.name}
              </DS.Text>
            </DS.Frame>
            <DS.Frame>
              <DS.Text variant="Caption/Regular" style={styles.status}>
                {handleStatus()}
              </DS.Text>
            </DS.Frame>
          </DS.Frame>
          <DS.Frame style={styles.playIcon}>{handlePlay()}</DS.Frame>
        </DS.Frame>
      </TouchableOpacity>
    )
  }
)

const styles = StyleSheet.create({
  icon: {},
  lessonBox: {
    flex: 1,
    width: '100%',
    marginTop: -3,
    paddingHorizontal: 8
  },
  lessonName: {
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  status: {
    color: '#68706D'
  },
  playIcon: {
    width: 24,
    height: 24
  }
})
